// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:18
import { ScatterDataPoint_abstract } from './../abstract/SagaBase/ScatterDataPoint_abstract';
export class ScatterDataPoint extends ScatterDataPoint_abstract {}
